import {
  STORE_SEARCH_SHOW,
  STORE_SEARCH_HIDE,
  CART_SAVE_SUCCESS,
  CART_SAVE_FAILED,
  APP_MOUNT,
} from '../actions/actionTypes';

const initialState = {
  display: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STORE_SEARCH_SHOW:
      return {
        ...state,
        display: true,
      };
    case APP_MOUNT:
      return {
        ...initialState,
      };
    case CART_SAVE_SUCCESS:
    case CART_SAVE_FAILED:
    case STORE_SEARCH_HIDE:
      return {
        ...state,
        display: false,
      };
    default:
      return state;
  }
};
